import LegalPageTemplate from "@/components/LegalPageTemplate";
import LegalDocument from "@/components/LegalDocument";
import { useLocale } from "@/lib/locale";

export default function MemorialPolicyPage() {
    const { t } = useLocale();
    return (
        <LegalPageTemplate
            docType="memorial"
            title={t("legal.memorial_title")}
            eyebrow={t("legal.memorial_eyebrow")}
            version="2026-02-v1"
        >
            <LegalDocument docKey="memorial" />
        </LegalPageTemplate>
    );
}
